module.exports = __webpack_public_path__ + "media/post-listing-block-5-overlay-wide.193d9c19.png";